import { render, staticRenderFns } from "./NetworkView.vue?vue&type=template&id=3861f9a0&"
import script from "./NetworkView.vue?vue&type=script&lang=js&"
export * from "./NetworkView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports